import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { FurnitureFilter } from '../../../../models/Filter';
import { FurnitureButtonFilterView } from '../../desktop/furniture/FurnitureButtonFilterView';

interface IFurnitureFilter {
    filter: FurnitureFilter;
    handleChange: (filter: FurnitureFilter) => void;
    isRoom?: boolean;
    classNameGroup?: string;
}

export const MobileFurnitureFilterButtonView: React.FC<IFurnitureFilter> = ({
    filter,
    handleChange,
    isRoom,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Мебель'>
            <FurnitureButtonFilterView
                filter={filter}
                handleChange={handleChange}
                isRoom={isRoom}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
